import { IHocSinhAceChiTietLoadStart } from "../../../models/request/hoc-sinh/IHocSinhAceChiTietLoadStart";
import { IBoDoiCongAn, IBoDoiCongAnVm } from "../../../models/response/hoc-sinh/IBoDoiCongAn";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objBoDoiCongAnDefine = {
    LOAD_START: {} as IHocSinhAceChiTietLoadStart,
    LOAD_SUCCESS: [] as IBoDoiCongAnVm[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IBoDoiCongAn | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IBoDoiCongAn,
    SAVE_SUCESS: {} as IBoDoiCongAn,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eBoDoiCongAnActionTypeIds = generateActionTypeIds(objBoDoiCongAnDefine, "BODOI_CONGAN")
export type IBoDoiCongAnActionTypes = IGenericActionType<typeof objBoDoiCongAnDefine, "BODOI_CONGAN">
